module.exports = __webpack_public_path__ + "static/media/logo_labore_colored.6543dee2.png";